import React from 'react';
import logo from '../../imgs/logo_komity.png';

function Caduca() {

    // 🎨 Mismo degradado de fondo que usa la pantalla de login
    const backgroundStyle = {
        height: '100vh',
        marginTop: "-10px",
        background: 'linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%)',
        position: 'relative',
        overflow: 'hidden'
    };

    return (
        <div className='d-flex justify-content-center align-items-center' style={backgroundStyle}>

            {/* Modal de Sesión Caducada */}
            <div className='card text-center p-4 shadow-lg' style={{ maxWidth: '600px', width: '100%', zIndex: 2 }}>
                <div className='card-body'>
                    <div className='mb-4'>
                        <img src={logo} alt="Logo Ventagix" className="img-fluid" style={{ maxHeight: '80px' }} />
                    </div>
                    
                    <div className="p-4 mb-4" style={{ borderRadius: '10px', backgroundColor: '#f1f3f5' }}>
                        <i className="bi bi-clock-history h1 mb-3" style={{ color: '#6c757d' }}></i>
                        <h4 className="font-weight-bold" style={{ color: '#495057' }}>Sesión finalizada</h4>
                        <p className="mb-0" style={{ color: '#6c757d' }}>Tu sesión se cerró por inactividad. Vuelve a iniciar sesión para continuar.</p>
                    </div>

                    <a href="/login/" className="btn btn-lg mt-3" style={{ width: '100%', backgroundColor: '#F26522', color: '#fff', fontWeight: 600 }}>
                        Iniciar Sesión
                    </a>
                </div>
            </div>
        </div>
    );
}

export default Caduca;
